import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { appointmentIsCancelable, formatHours, formatPhone } from '../../utils/helpers';
import Subtitle from '../../components/Subtitle';
import ReservationError from './ReservationError';
import ReservationInfo from './ReservationInfo';
import ShopMap from './ShopMap';
import Controls from './Controls';
import Modals from './Modals';
import ProcessingIndicator from '../containers/ProcessingIndicator';
import PromoTidalReservation from '../containers/PromoTidalReservation';

const CONFIRM_MODAL = 'confirmModal';

class ViewReservation extends Component {
  state = {
    confirmModal: { open: false },
  };

  componentWillMount() {
    this.props.fetchReservation();
  }

  getAppointmentCancelable() {
    return appointmentIsCancelable(this.props.appointment.start, this.props.advanceCancelMins) &&
      this.props.canCustomerCancel;
  }

  cancelAppointment = () => {
    this.closeConfirmModal();
    setTimeout(() => { // Prevent race condition on multiple SweetAlert modals
      this.props.cancelAppointment();
    });
  };

  openModal(modal) {
    this.setState({ [modal]: { open: true } });
  }

  closeModal(modal) {
    this.setState({ [modal]: { open: false } });
  }

  openConfirmModal = () => this.openModal(CONFIRM_MODAL);
  closeConfirmModal = () => this.closeModal(CONFIRM_MODAL);

  renderControls() {
    if (this.props.children) return null;
    const {
      canceled,
      inFuture,
      barberName,
      serviceName,
      shop,
      customer,
      appointment,
      rebookLink,
      scheduleLink,
      clearReservations,
    } = this.props;

    return (
      <Controls
        {...{
          isCancelable: this.getAppointmentCancelable(),
          cancelAppointment: this.openConfirmModal,
          canceled,
          inFuture,
          barberName,
          serviceName,
          shop,
          customer,
          appointment,
          rebookLink,
          scheduleLink,
          clearReservations,
        }}
      />
    );
  }

  renderModals() {
    return (
      <Modals
        {...{
          confirmModal: { ...this.state.confirmModal },
          closeConfirmModal: this.closeConfirmModal,
          cancelAppointment: this.cancelAppointment,
        }}
      />
    );
  }

  renderMessage() {
    if (!this.props.children) {
      return 'Canceling Order';
    }

    if (this.props.children.type.displayName === 'CheckoutContainer') {
      return 'Processing';
    }

    return 'Rescheduling';
  }

  render() {
    const {
      reservationError,
      barberName,
      serviceName,
      appointment,
      shop,
      advanceCancelMins,
      promoCode,
    } = this.props;

    const shopInfo = `${shop.name}${shop.phone ? ` at ${formatPhone(shop.phone)}` : ''}`;
    const isCancelable = this.getAppointmentCancelable();

    return (
      <div>
        <Subtitle>
          Appointment Details
        </Subtitle>
        { reservationError && <ReservationError error={reservationError} />}
        { !reservationError &&
          <div className="layout layout--large u-mt+">
            <div className="layout__item u-1/2-medium-and-up">
              <ReservationInfo
                barberName={barberName}
                serviceName={serviceName}
                appointment={appointment}
                shop={shop}
              />
              {this.renderControls()}
            </div>
            {promoCode && (
              <div className="layout__item u-1/2-medium-and-up">
                <PromoTidalReservation promoCode={promoCode} />
              </div>
            )}
            <div className="layout__item u-1/2-medium-and-up">
              {shop.location &&
                <div className="u-mb-">
                  <ShopMap name={shop.name} address={shop.address} />
                </div>
              }
              {isCancelable && <p>
                According to the cancellation policy of {shop.name}, this
              appointment could be canceled/rescheduled up to{' '}
                {formatHours(advanceCancelMins)} before it is set to begin. If a
              payment was included when scheduling this appointment, it will be
              fully refunded upon cancellation.  For all other inquiries please
              call the {shopInfo}.
            </p>}
              {!isCancelable && <p>
                According to the cancellation policy of {shop.name} you cannot cancel this appt at this time.
              Please contact {shopInfo} for more information.
            </p>}
            </div>
            {this.renderModals()}
          </div>}
        {this.props.children}
        <ProcessingIndicator>
          {this.renderMessage()}
        </ProcessingIndicator>
      </div>
    );
  }
}

ViewReservation.propTypes = {
  fetchReservation: PropTypes.func.isRequired,
  reservationError: PropTypes.string,
  appointment: PropTypes.shape({
    start: PropTypes.string,
    formatted: PropTypes.string,
    duration: PropTypes.number,
  }).isRequired,
  barberName: PropTypes.string,
  serviceName: PropTypes.string,
  shop: PropTypes.shape({
    name: PropTypes.string.isRequired,
    address: PropTypes.string,
    zip: PropTypes.string,
    location: PropTypes.shape({
      lat: PropTypes.number,
      lng: PropTypes.number,
    }),
  }).isRequired,
  customer: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    id: PropTypes.string,
  }).isRequired,
  cancelAppointment: PropTypes.func.isRequired,
  advanceCancelMins: PropTypes.number,
  canCustomerCancel: PropTypes.bool.isRequired,
  inFuture: PropTypes.bool,
  canceled: PropTypes.bool,
  rebookLink: PropTypes.string,
  children: PropTypes.node,
  scheduleLink: PropTypes.string,
  clearReservations: PropTypes.func.isRequired,
  promoCode: PropTypes.string,
};

ViewReservation.defaultProps = {
  reservationError: '',
  barberName: '',
  serviceName: '',
  advanceCancelMins: 60,
  inFuture: false,
  canceled: true,
  rebookLink: '/',
  children: null,
  scheduleLink: '/',
  promoCode: null,
};


export default ViewReservation;



// WEBPACK FOOTER //
// ./src/app/reservation/components/ViewReservation.jsx